package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config

import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class PMSType(
    val value: String
) : TitleEnum {
    DISABLED(
        value = "disabled"
    ),
    PROTEL(
        value = "protel"
    ),
    APALEO(
        value = "apaleo"
    );


    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                DISABLED -> strings.disable
                PROTEL -> strings.protel
                APALEO -> strings.apaleo
            }
        }
}